import { render, staticRenderFns } from "./CreateLayout.vue?vue&type=template&id=4e5abd61&scoped=true&"
import script from "./CreateLayout.vue?vue&type=script&lang=ts&"
export * from "./CreateLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLayout.vue?vue&type=style&index=0&id=4e5abd61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5abd61",
  null
  
)

export default component.exports